//services
import { getSuggestedAltshulerAccountByCompanyId, validateStep1 } from 'services/balance.services';

//reducers
import {
	getCompanyBankAccount,
	isLoading,
	setCompanyBankAccount,
	getAddBalanceState,
} from 'state/reducers/balance.reducers';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { getExistingBankAccounts } from 'state/reducers/bank-account.reducers';

//components
import BankAccountDetailsForm from './BankAccountDetailsForm';
//sections
//mui
import { Button, Stack } from '@mui/material';
import { LoadingButton } from '@mui/lab';
//constants

import _ from 'lodash';
import { Fragment, useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { getAltshulerAccountsByCompanyId, getBankAccountsByCompanyId } from 'services/bank-account.services';
import WaitingMessage from 'components/WaitingMessage';
import { getMobile } from 'state/reducers/ui.reducers';
import { digitalBalanceAddStepsPrefix, balanceTransStepsPrefix, BalanceDepositType } from 'constants/balance.constants';
import { FormButton } from 'theme/elements/Buttons';

export default function Step1(props: { handleCancel: any }) {
	const dispatch = useAppDispatch();
	const t = useAppSelector(selectTranslations);
	const balanceState = useAppSelector(getAddBalanceState);
	const companyBankAccountId = useAppSelector(getCompanyBankAccount);
	const existBankAccounts = useAppSelector(getExistingBankAccounts);
	const isBalanceLoading = useAppSelector(isLoading);
	const isMobile = useAppSelector(getMobile);
	const isContinueDisabled = useMemo(() => {
		return isBalanceLoading || !companyBankAccountId;
	}, [isBalanceLoading, companyBankAccountId]);

	const bankAccountsForCurrentFlow = useMemo(() => {
		if (balanceState !== BalanceDepositType.Digital) {
			return existBankAccounts;
		}

		const supported = existBankAccounts.filter((a) => a.bankName.isDigitalDepositSupported === true);
		const available = supported.filter((a) => a.bankName.isDigitalDepositTemporarilyUnavailable !== true);
		const temporarilyUnavailable = supported.filter((a) => a.bankName.isDigitalDepositTemporarilyUnavailable === true);

		return [...available, ...temporarilyUnavailable];
	}, [existBankAccounts, balanceState]);

	// Dynamic translation prefix
	const translationPrefix = balanceState === BalanceDepositType.Digital ? digitalBalanceAddStepsPrefix : balanceTransStepsPrefix;

	const handleBankListPick = (accountId: number) => {
		dispatch(setCompanyBankAccount(accountId));
	};

	const handleFormData = () => {
		dispatch(validateStep1());
	};

	return (
		<Stack spacing={{ sm: 4, xs: 2 }}>
			<BankAccountDetailsForm
				accounts={bankAccountsForCurrentFlow}
				handleBankListPick={handleBankListPick}
				companyBankAccountId={companyBankAccountId}
			/>
			<Stack justifyContent="space-between" direction="row" marginTop="32px">
				{!isMobile && (
					<FormButton>
						<Button disabled={isBalanceLoading} variant="text" onClick={props.handleCancel}>
							{t(`${translationPrefix}.1.cancel_button.text`)}
						</Button>
					</FormButton>
				)}
				<FormButton>
					<Button
						className="singleFormButton"
						variant="contained"
						disabled={isContinueDisabled}
						onClick={handleFormData}
					>
						{t(`${translationPrefix}.1.continue_button.text`)}
					</Button>
				</FormButton>
			</Stack>
		</Stack>
	);
}
